@let testIdPrefix = 'rcp-vso-review-qr';

<app-review-qr-details
    [actions]="actions()"
    [testIdPrefix]="testIdPrefix"
>
</app-review-qr-details>
